import styled from "@emotion/styled";

export const NotFoundButtonsContainer = styled.div`
  display: flex;
`;
